import mediaQueries from "../styles/media-queries";
import icons from "../imgs/icons";
import backgrounds from "../imgs/backgrounds";

const wrapper = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: 1000,
  backgroundColor: "rgba(255, 255, 255, 0.8)"
};

const closeButton = {
  display: "block",
  height: "26px",
  width: "26px",
  position: "absolute",
  right: "0",
  top: "-33px",
  background: `url(${icons.closeIcon}) no-repeat center center`,
  borderRadius: "3px",
  padding: "5px",
  backgroundSize: "90%",
  border: "none",
  cursor: "pointer"
};

const frameWrapper = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(100% - 32px)",
  height: "50%",
  margin: "0 auto",
  background: `transparent url(${backgrounds.video}) no-repeat center center`,
  backgroundSize: "100%",
  [mediaQueries.tablet]: {
    width: "55%",
    height: "55%"
  }
};

const playWrapper = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
};

const playButton = {
  height: "95px",
  width: "60px",
  background: `url(${icons.playVideo}) no-repeat`,
  backgroundSize: "100%",
  border: "none",
  cursor: "pointer",
  opacity: 0.7
};

export default { wrapper, closeButton, frameWrapper, playWrapper, playButton };



// WEBPACK FOOTER //
// ./src/styles/video.js